<!-- Payment Report -->
<div class="payment-report-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-main">
        <div class="header-icon">
          <i class="fas fa-file-invoice-dollar"></i>
        </div>
        <div class="header-text">
          <h1 class="page-title">Payment Report</h1>
          <p class="page-description">Monitor payment transactions and waiter performance</p>
        </div>
      </div>
      <div class="header-actions">
        <button class="btn btn-outline-secondary"
                [disabled]="isLoading"
                (click)="loadReportData()">
          <i class="fas fa-sync-alt me-1" [class.fa-spin]="isLoading"></i>Refresh
        </button>
        <button class="btn btn-primary"
                [disabled]="isExporting"
                (click)="exportToExcel()">
          <i class="fas fa-file-excel me-1" *ngIf="!isExporting"></i>
          <i class="fas fa-spinner fa-spin me-1" *ngIf="isExporting"></i>
          {{isExporting ? 'Exporting...' : 'Export'}}
        </button>
      </div>
    </div>
  </div>

  <!-- KPI Summary Cards -->
  <div class="row g-3 mb-4">
    <!-- Total Cash -->
    <div class="col-xl-4 col-md-6">
      <div style="background: var(--card-bg); border: 1px solid var(--card-border); border-radius: var(--radius-lg); padding: 20px; box-shadow: var(--card-shadow);">
        <div class="d-flex align-items-start justify-content-between mb-3">
          <div style="width: 42px; height: 42px; border-radius: var(--radius-md); background: var(--success-bg); color: var(--success-text); display: flex; align-items: center; justify-content: center; font-size: 16px;">
            <i class="fas fa-money-bill-wave"></i>
          </div>
        </div>
        <div style="font-size: 12px; font-weight: 500; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 6px;">Total Cash</div>
        <div *ngIf="!isLoadingSummary" style="font-size: 24px; font-weight: 700; color: var(--text-primary); line-height: 1.2;">
          ₦{{(summaryCards[0].value | number:'1.2-2') || '0.00'}}
        </div>
        <div *ngIf="isLoadingSummary">
          <div class="loading-shimmer" style="height: 32px; width: 140px; border-radius: 6px;"></div>
        </div>
      </div>
    </div>

    <!-- Total Transfer -->
    <div class="col-xl-4 col-md-6">
      <div style="background: var(--card-bg); border: 1px solid var(--card-border); border-radius: var(--radius-lg); padding: 20px; box-shadow: var(--card-shadow);">
        <div class="d-flex align-items-start justify-content-between mb-3">
          <div style="width: 42px; height: 42px; border-radius: var(--radius-md); background: var(--info-bg); color: var(--info-text); display: flex; align-items: center; justify-content: center; font-size: 16px;">
            <i class="fas fa-university"></i>
          </div>
        </div>
        <div style="font-size: 12px; font-weight: 500; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 6px;">Total Transfer</div>
        <div *ngIf="!isLoadingSummary" style="font-size: 24px; font-weight: 700; color: var(--text-primary); line-height: 1.2;">
          ₦{{(summaryCards[1].value | number:'1.2-2') || '0.00'}}
        </div>
        <div *ngIf="isLoadingSummary">
          <div class="loading-shimmer" style="height: 32px; width: 140px; border-radius: 6px;"></div>
        </div>
      </div>
    </div>

    <!-- Total POS -->
    <div class="col-xl-4 col-md-6">
      <div style="background: var(--card-bg); border: 1px solid var(--card-border); border-radius: var(--radius-lg); padding: 20px; box-shadow: var(--card-shadow);">
        <div class="d-flex align-items-start justify-content-between mb-3">
          <div style="width: 42px; height: 42px; border-radius: var(--radius-md); background: var(--warning-bg); color: var(--warning-text); display: flex; align-items: center; justify-content: center; font-size: 16px;">
            <i class="fas fa-credit-card"></i>
          </div>
        </div>
        <div style="font-size: 12px; font-weight: 500; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 6px;">Total POS</div>
        <div *ngIf="!isLoadingSummary" style="font-size: 24px; font-weight: 700; color: var(--text-primary); line-height: 1.2;">
          ₦{{(summaryCards[2].value | number:'1.2-2') || '0.00'}}
        </div>
        <div *ngIf="isLoadingSummary">
          <div class="loading-shimmer" style="height: 32px; width: 140px; border-radius: 6px;"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Collapsible Filters Panel -->
  <div class="filters-panel" style="margin-bottom: 20px;">
    <div style="display: flex; align-items: center; justify-content: space-between; cursor: pointer; padding-bottom: 0;"
         (click)="toggleFiltersCollapse()">
      <div style="display: flex; align-items: center; gap: 12px;">
        <div style="width: 32px; height: 32px; border-radius: var(--radius-sm); background: var(--accent-subtle); color: var(--accent); display: flex; align-items: center; justify-content: center; font-size: 14px;">
          <i class="fas fa-sliders-h"></i>
        </div>
        <div>
          <div style="font-size: 14px; font-weight: 600; color: var(--text-primary);">Filters</div>
          <div style="font-size: 12px; color: var(--text-tertiary);">{{isFiltersCollapsed ? 'Click to expand' : 'Filter by date range'}}</div>
        </div>
      </div>
      <div style="display: flex; align-items: center; gap: 10px;">
        <i class="fas fa-chevron-down" [class.rotated]="!isFiltersCollapsed"
           style="font-size: 12px; color: var(--text-tertiary); transition: transform 0.3s ease;"
           [style.transform]="!isFiltersCollapsed ? 'rotate(180deg)' : 'rotate(0deg)'"></i>
      </div>
    </div>

    <div [@slideDown]="isFiltersCollapsed ? 'collapsed' : 'expanded'"
         [class.collapsed]="isFiltersCollapsed">
      <div style="padding-top: 16px; border-top: 1px solid var(--border-subtle); margin-top: 16px;">
        <!-- Date Range Quick Buttons -->
        <div style="margin-bottom: 14px;">
          <label style="font-size: 12px; font-weight: 600; color: var(--text-secondary); display: flex; align-items: center; gap: 6px; margin-bottom: 8px;">
            <i class="fas fa-calendar-alt" style="font-size: 12px;"></i>Date Range
          </label>
          <div style="display: flex; gap: 6px; flex-wrap: wrap;">
            <button class="btn btn-sm"
                    [class.btn-primary]="selectedDateFilter === 'all'"
                    [class.btn-tertiary]="selectedDateFilter !== 'all'"
                    (click)="onDateFilterChange('all')">
              All Time
            </button>
            <button class="btn btn-sm"
                    [class.btn-primary]="selectedDateFilter === 'today'"
                    [class.btn-tertiary]="selectedDateFilter !== 'today'"
                    (click)="onDateFilterChange('today')">
              Today
            </button>
            <button class="btn btn-sm"
                    [class.btn-primary]="selectedDateFilter === 'yesterday'"
                    [class.btn-tertiary]="selectedDateFilter !== 'yesterday'"
                    (click)="onDateFilterChange('yesterday')">
              Yesterday
            </button>
            <button class="btn btn-sm"
                    [class.btn-primary]="selectedDateFilter === 'custom'"
                    [class.btn-tertiary]="selectedDateFilter !== 'custom'"
                    (click)="onDateFilterChange('custom')">
              <i class="fas fa-calendar-alt me-1"></i>Custom Range
            </button>
          </div>
        </div>

        <!-- Custom Date Inputs -->
        <div *ngIf="showDatePicker" style="padding-top: 12px; border-top: 1px solid var(--border-subtle);">
          <div class="row g-3">
            <div class="col-md-5">
              <label class="form-label">Start Date</label>
              <input type="date"
                     class="form-control"
                     #startDate
                     placeholder="Select start date">
            </div>
            <div class="col-md-5">
              <label class="form-label">End Date</label>
              <input type="date"
                     class="form-control"
                     #endDate
                     placeholder="Select end date">
            </div>
            <div class="col-md-2">
              <label class="form-label">&nbsp;</label>
              <button class="btn btn-primary d-block w-100"
                      (click)="onCustomDateSelect(startDate.value, endDate.value)">
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Waiter Payment Report Table -->
  <div class="data-panel">
    <div class="panel-header">
      <div class="panel-title">
        <div class="title-icon"><i class="fas fa-user-tie"></i></div>
        <div>
          <div class="title-text">Waiter Payment Report</div>
          <div class="title-subtitle">Complete breakdown of payment methods by waiter</div>
        </div>
      </div>
      <div class="panel-info">
        <span class="info-item" style="font-size: 12px; color: var(--text-tertiary);">
          <span *ngIf="!isLoadingWaiterData">
            <span class="info-value" style="font-weight: 600; color: var(--text-secondary);">{{waiterPayments.length}}</span> records
          </span>
          <span *ngIf="isLoadingWaiterData">
            <i class="fas fa-spinner fa-spin me-1"></i>Loading...
          </span>
        </span>
      </div>
    </div>
    <div class="panel-body table-container">
      <table class="table">
        <thead>
          <tr>
            <th>Waiter Name</th>
            <th>Cash</th>
            <th>POS</th>
            <th>Transfer</th>
            <th>Total Amount</th>
            <th style="width: 60px;">Actions</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loading State -->
          <tr *ngIf="isLoadingWaiterData">
            <td colspan="6">
              <div class="loading-state">
                <div class="loading-content">
                  <div class="loading-spinner">
                    <div class="spinner-ring"></div>
                  </div>
                  <div class="loading-text">
                    <h5>Loading payment data</h5>
                    <p>Please wait while we fetch the payment report</p>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <!-- Data Rows -->
          <tr *ngFor="let payment of waiterPayments; let i = index">
            <td>
              <div style="display: flex; align-items: center; gap: 10px;">
                <div style="width: 36px; height: 36px; border-radius: 50%; background: var(--accent-subtle); color: var(--accent); display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 600; flex-shrink: 0;">
                  {{payment.waiter_name.charAt(0)}}
                </div>
                <div>
                  <div style="font-size: 13px; font-weight: 500; color: var(--text-primary);">{{payment.waiter_name}}</div>
                  <div style="font-size: 11px; color: var(--text-tertiary);">Waiter</div>
                </div>
              </div>
            </td>
            <td>
              <div style="display: flex; align-items: center; gap: 6px;">
                <i class="fas fa-money-bill-wave" style="font-size: 11px; color: var(--success-text);"></i>
                <span style="font-weight: 500; color: var(--text-primary);">{{payment.cash | currency:'₦'}}</span>
              </div>
            </td>
            <td>
              <div style="display: flex; align-items: center; gap: 6px;">
                <i class="fas fa-credit-card" style="font-size: 11px; color: var(--warning-text);"></i>
                <span style="font-weight: 500; color: var(--text-primary);">{{payment.pos | currency:'₦'}}</span>
              </div>
            </td>
            <td>
              <div style="display: flex; align-items: center; gap: 6px;">
                <i class="fas fa-university" style="font-size: 11px; color: var(--info-text);"></i>
                <span style="font-weight: 500; color: var(--text-primary);">{{payment.transfer | currency:'₦'}}</span>
              </div>
            </td>
            <td>
              <span style="font-size: 14px; font-weight: 700; color: var(--accent);">{{payment.total_amount | currency:'₦'}}</span>
            </td>
            <td>
              <button class="btn btn-sm btn-outline-secondary" title="View Details" style="padding: 4px 8px;">
                <i class="fas fa-eye"></i>
              </button>
            </td>
          </tr>

          <!-- Empty State -->
          <tr *ngIf="!isLoadingWaiterData && waiterPayments.length === 0">
            <td colspan="6">
              <div class="empty-state">
                <div class="empty-icon"><i class="fas fa-file-invoice-dollar" style="font-size: 32px;"></i></div>
                <h5 class="empty-title">No payment data available</h5>
                <p class="empty-subtitle">There are no payment records for the selected date range.</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
